<template>
	<div class="stats">
		<h2 class="stats-title">Overview</h2>
		<div class="stats-container">
			<stats-card
				:quantity="incompleteCalls.urgent"
				title="Total Urgent"
				urgent
				sub-title="Incomplete Calls"
				:is-active="isActive('urgent')"
				@click="toggleActive('urgent')"
			/>
			<stats-card
				non-urgent
				:quantity="incompleteCalls.nonUrgent"
				title="Total Non Urgent"
				sub-title="Incomplete Calls"
				:is-active="isActive('nonUrgent')"
				@click="toggleActive('nonUrgent')"
			/>
			<stats-card
				v-if="hasPagingEnabled"
				:quantity="incompletePages.total"
				title="Total Pages"
				paging
				sub-title="Incomplete Pages"
				:is-active="isActive('paging')"
				@click="toggleActive('paging')"
			/>
		</div>
		<h2 class="stats-title">Call Types</h2>
		<div class="stats-container">
			<stats-card
				v-for="type in types"
				:id="type.id"
				:key="type.id"
				:quantity="type.total"
				:title="type.name"
				sub-title="Incomplete Calls"
				:is-active="isActive(type.id)"
				@click="toggleActive(type.id)"
			/>
		</div>
	</div>
</template>

<script>
import StatsCard from '@/components/StatsCard'
import { mapActions, mapGetters, mapState } from 'vuex'
import { CALL_SOURCE } from '@/config/calls'

export default {
	/**
	 * The component's registered child components.
	 *
	 * @type {Object}
	 */
	components: {
		StatsCard,
	},

	/**
	 * The component's computed properties.
	 *
	 * @type {Object}
	 */
	computed: {
		activeFilterId() {
			if (
				this.callFilters.statuses.length === 1 &&
				this.callFilters.statuses[0] === 'incomplete'
			) {
				if (
					this.callFilters.types.length === 1 &&
					!this.callFilters.urgent &&
					!this.callFilters.nonUrgent &&
					!this.callSource.includes(CALL_SOURCE.PAGES) &&
					this.callFilters.officeHours.length === 0
				) {
					return this.callFilters.types[0].id
				}
				if (
					this.callFilters.urgent &&
					!this.callFilters.nonUrgent &&
					!this.callSource.includes(CALL_SOURCE.PAGES) &&
					this.callFilters.officeHours.length === 0
				) {
					return 'urgent'
				}
				if (
					this.callFilters.nonUrgent &&
					!this.callFilters.urgent &&
					!this.callSource.includes(CALL_SOURCE.PAGES) &&
					this.callFilters.officeHours.length === 0
				) {
					return 'nonUrgent'
				}
				if (
					Array.isArray(this.callSource) &&
					this.callSource.length === 1 &&
					this.callSource[0] === 'page' &&
					!this.callFilters.urgent &&
					!this.callFilters.nonUrgent &&
					this.callFilters.types.length === 0 &&
					this.callFilters.officeHours.length === 0
				) {
					return 'paging'
				}
				return 'incomplete'
			}
			return ''
		},

		...mapGetters({
			hasPagingEnabled: 'partners/hasPagingEnabled',
			partner: 'partner',
			types: 'callTypes',
		}),

		...mapState({
			activePartnerId: state => state.partners.active,
			incompleteCalls: state => state.calls.incomplete,
			incompletePages: state => state.pages.incomplete,
			user: state => state.auth.user,
			callFilters: state => state.calls.filters,
			callSource: state => state.calls.source,
		}),
	},

	/**
	 * The component's local methods.
	 *
	 * @type {Object}
	 */
	methods: {
		isActive(cardId) {
			return this.activeFilterId === cardId
		},

		toggleActive(cardId) {
			this.activeCard = this.activeCard === cardId ? null : cardId
		},

		async syncIncompletePagingCount() {
			if (!this.hasPagingEnabled) {
				return
			}
			await this.getIncompletePagingCount()
		},

		...mapActions('pages', ['getIncompletePagingCount']),
	},

	/**
	 * The component's name used for debugging.
	 *
	 * @type {String}
	 */
	name: 'Index',

	/**
	 * The component's property watchers.
	 *
	 * @type {Object}
	 */
	watch: {
		/**
		 * Active user watcher.
		 *
		 * @type {Object}
		 */
		user: {
			handler: 'updateIntercom',
			immediate: true,
		},

		activePartnerId: {
			handler() {
				this.syncIncompletePagingCount()
			},
		},
	},

	async created() {
		await this.syncIncompletePagingCount()
	},

	data() {
		return {
			activeCard: null,
		}
	},
}
</script>
